import api from '../api/api';

export const purchasePaymentsService = {
  async list() {
    const res = await api.get('/purchase-payments');
    return res.data; // [] ou { items, total }
  },

  async create(payload) {
    const res = await api.post('/purchase-payments', payload);
    return res.data;
  },

  async update(id, payload) {
    const res = await api.put(`/purchase-payments/${id}`, payload);
    return res.data;
  },

  async remove(id) {
    const res = await api.delete(`/purchase-payments/${id}`);
    return res.data;
  },

  async listOpenInvoices(supplierId) {
    const res = await api.get('/purchase-invoices/open', { params: { supplierId } });
    return res.data; // attendu: [] ou { items, total }
  },
};
